export class MarketplaceListController {
}
